<template>
  <Layout>
    <div class="cs-modal" v-if="informationModal">
      <div class="cs-modal__body py-60">
        <div class="text-center">
          <p
            class="h4 mb-30"
            :class="[informationModal.class || 'text-primary']"
          >
            {{ informationModal.title }}
          </p>
          <p
            class="text-gray-soft h6 fw-500 mb-10"
            v-html="informationModal.content"
          ></p>
        </div>
      </div>
    </div>

    <div
      class="quiz-overlay"
      :class="{
        active: liveStatusIsOpen || reviewIsOpen || completeQuizIsOpen,
      }"
      @click="closeLeftMenus"
    ></div>

    <div class="live-status" :class="{ active: liveStatusIsOpen }">
      <div
        class="live-status-header d-flex align-items-center justify-content-between mb-3"
      >
        <span class="h4 mb-0">ANLIK DURUM</span>
        <button
          class="btn btn-danger rounded shadow-sm px-3"
          @click="liveStatusIsOpen = false"
        >
          KAPAT
        </button>
      </div>

      <div class="live-status-content">
        <div class="row text-center live-status-table mx-0 mb-30">
          <div class="col-12 px-0 head">Test Bilgileri</div>
          <div class="col-3 px-0 head">Test Adı</div>
          <div class="col-3 px-0 head">Toplam S. Sayısı</div>
          <div class="col-3 px-0 head">Cevaplanan S. Sayısı</div>
          <div class="col-3 px-0 head">Cevaplanmayan S. Sayısı</div>

          <div class="col-3 px-0 cell big-font">
            {{ userSession.translate && userSession.translate.title }}
          </div>
          <div class="col-3 px-0 cell big-font">{{ questions.length }}</div>
          <div class="col-3 px-0 cell big-font">
            {{
              questions.filter((elm) => elm.answered && elm.answer_id !== 0)
                .length
            }}
          </div>
          <div class="col-3 px-0 cell big-font">
            {{
              questions.length -
              questions.filter((elm) => elm.answered && elm.answer_id !== 0)
                .length
            }}
          </div>
        </div>

        <div class="row text-center live-status-table mx-0 mb-30">
          <div class="col-12 px-0 head">Anlık Süre Bilgileri</div>

          <div class="col-4 px-0 head">Başlama Saati</div>
          <div class="col-4 px-0 head">Bitiş Saati</div>
          <div class="col-4 px-0 head">Sınav Süresi</div>

          <div class="col-4 px-0 cell big-font">
            {{ userSession.session && getStartTime() }}
          </div>
          <div class="col-4 px-0 cell big-font">
            {{ userSession.session && getEndTime() }}
          </div>
          <div class="col-4 px-0 cell big-font">
            {{ userSession.exam_duration }} dk
          </div>

          <div class="col-6 px-0 head">Geçen Süre</div>
          <div class="col-6 px-0 head">Kalan Süre</div>
          <!--                    <div class="col-4 px-0 head">Soru Başına Ort. Süre</div>-->

          <div class="col-6 px-0 cell big-font">{{ spended }}</div>
          <div class="col-6 px-0 cell big-font">{{ remaining }}</div>
          <!--                    <div class="col-4 px-0 cell big-font">0 dk</div>-->
        </div>
      </div>
    </div>

    <div class="review-grid" :class="{ active: reviewIsOpen }">
      <div class="left">
        <div
          class="live-status-header d-flex align-items-center justify-content-between mb-3"
        >
          <span class="h4 mb-0">GÖZDEN GEÇİR</span>
          <button
            class="btn btn-danger rounded shadow-sm px-3"
            @click="reviewIsOpen = false"
            :disabled="typeof this.showRightInstance !== 'undefined'"
          >
            KAPAT
          </button>
        </div>

        <div class="live-status-content">
          <ul class="q-filter-tab mb-3">
            <li
              :class="{ active: isActiveTab('all') }"
              @click="setActiveTab('all')"
            >
              Tüm Sorular
            </li>
            <li
              class="dot answered"
              :class="{ active: isActiveTab('answered') }"
              @click="setActiveTab('answered')"
            >
              Cevapladıklarım
            </li>
            <li
              :class="{ active: isActiveTab('marked') }"
              @click="setActiveTab('marked')"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.72494 17.3985C4.63081 17.4614 4.52134 17.4977 4.40822 17.5032C4.29511 17.5088 4.18261 17.4836 4.08274 17.4301C3.98286 17.3767 3.89938 17.2972 3.84121 17.2C3.78303 17.1029 3.75235 16.9917 3.75244 16.8785V5.01473C3.75244 4.35256 4.01515 3.71743 4.48291 3.24873C4.95067 2.78003 5.58527 2.51606 6.24744 2.51473L13.7474 2.50098C14.0757 2.50032 14.401 2.56434 14.7045 2.68937C15.0081 2.8144 15.2841 2.998 15.5167 3.22968C15.7493 3.46136 15.934 3.73659 16.0602 4.03965C16.1865 4.34272 16.2518 4.66768 16.2524 4.99598V16.8785C16.2525 16.9917 16.2219 17.1029 16.1637 17.2C16.1055 17.2972 16.022 17.3767 15.9221 17.4301C15.8223 17.4836 15.7098 17.5088 15.5967 17.5032C15.4835 17.4977 15.3741 17.4614 15.2799 17.3985L10.0024 13.8735L4.72369 17.3985H4.72494Z"
                  fill="#FE9A38"
                />
              </svg>

              İşaretlediklerim
            </li>
            <li
              class="dot empty"
              :class="{ active: isActiveTab('empty') }"
              @click="setActiveTab('empty')"
            >
              Boş Bıraktıklarım
            </li>
          </ul>

          <div class="overflow-auto">
            <ul class="review-nums">
              <li
                class="review-num"
                v-for="(question, index) in filteredQuestions"
                :key="index"
                :class="{
                  answered: question.answered && question.answer_id !== 0,
                  marked: markedQuestions.includes(question.id),
                  active: question.id === currentQuestion.id,
                  disabled: typeof showRightInstance !== 'undefined',
                }"
                @click="goQuestion()"
                @mouseover="showRight(question.index)"
              >
                {{ question.index + 1 }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="right" v-if="showRightReview">
        <div class="exam-container">
          <!--
                    <div class="q-alert q-alert__info mb-3">7-15 sorularda, cümlede boş bırakılan yerlere uygun düşen sözcük ya da ifadeyi bulunuz.</div>
                    -->

          <p class="text">
            <span class="d-block">{{ this.currentQuestion.index + 1 }}.</span>
            <span v-html="getCurrentQuestion().detail.translate.content"></span>
          </p>

          <div class="exam-options" v-if="getCurrentQuestion().detail.answers">
            <label
              @contextmenu.prevent="lineThrought(answer.id)"
              class="exam-option"
              :class="{
                selected: answer.id === currentQuestion.answer_id,
                lineThrough:
                  questionEliminatedOptions.hasOwnProperty(
                    currentQuestion.id,
                  ) &&
                  questionEliminatedOptions[currentQuestion.id] &&
                  questionEliminatedOptions[currentQuestion.id].includes(
                    answer.id,
                  ) &&
                  answer.id !== currentQuestion.answer_id,
              }"
              v-for="(answer, key) in getCurrentQuestion().detail.answers"
              :key="answer.id"
            >
              <span class="opt-key text-uppercase">{{
                  getQuestionAnswerLabel(key)
                }}</span>
              <span class="opt-text" v-html="answer.translate.content"></span>
              <input
                type="radio"
                :id="answer.id"
                class="hidden"
                :value="answer.id"
                @change="setAnswer(answer.id)"
                v-model="currentQuestion.answer_id"
              />
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="live-status" :class="{ active: completeQuizIsOpen }">
      <div
        class="live-status-header d-flex align-items-center justify-content-between mb-3"
      >
        <span class="h4 mb-0">Sınavı Sonlandır</span>

        <button
          class="btn btn-danger rounded shadow-sm px-3"
          @click="completeQuizIsOpen = false"
        >
          KAPAT
        </button>
      </div>

      <div class="live-status-content">
        <div class="q-alert q-alert__danger mb-3 d-flex">
          <i class="icon-alert mt-5 mr-10"></i>
          <p class="mb-0 fw-400">
            Sınav sonlandırdıktan sonra tekrar sınava devam edemezsiniz. Sınavı
            sonlandırsanız dahi sınavdan çıkabileceğiniz süre dolmadan salondan
            ayrılamazsınız.
          </p>
        </div>

        <button
          class="btn btn-primary w-100 py-20 rounded-sm"
          @click="finishExam"
        >
          Anladım, Sınavı Sonlandırmak İstiyorum.
        </button>
      </div>
    </div>

    <div class="bla-card">
      <div class="bla-card__header">
        <div class="first">
          <span class="first__title">{{
              userSession.translate && userSession.translate.title
            }}</span>

          <div class="font-sizer">
            <button
              type="button"
              class="font-sizer__btn"
              :disabled="fontSize <= minFontSize"
              @click="changeFontSize(-1)"
              title="Yazıyı küçült"
            >
              <span class="font-sizer__a font-sizer__a--sm">A</span>
              <span class="font-sizer__sign">−</span>
            </button>

            <span class="font-sizer__value">{{ fontSize }} px</span>

            <button
              type="button"
              class="font-sizer__btn"
              :disabled="fontSize >= maxFontSize"
              @click="changeFontSize(1)"
              title="Yazıyı büyüt"
            >
              <span class="font-sizer__a font-sizer__a--lg">A</span>
              <span class="font-sizer__sign">＋</span>
            </button>
          </div>
        </div>

        <div class="second">
          <div class="left">
            <div
              class="user-img"
              style="background-image: url('')"
              v-bind:style="{
                'background-image':
                  'url(' +
                  (this.$root.user.avatar && this.$root.user.avatar.thumb
                    ? this.$root.user.avatar.thumb.small
                    : this.$root.getWebSiteURL() +
                      '/system/icon/avatar-man.jpeg') +
                  ')',
              }"
            ></div>
            <span class="text ml-5 w-75">{{ this.$root.user.full_name }}</span>
          </div>

          <div class="center">
            <ul class="quiz-cta-btns">
              <li @click="liveStatusIsOpen = true">
                <i class="icon-time"></i>
                <span class="txt ml-5">Anlık Durum</span>
              </li>

              <li @click="reviewIsOpen = true">
                <i class="icon-book"></i>
                <span class="txt ml-5">Gözden Geçir</span>
              </li>

              <li @click="completeQuizIsOpen = true">
                <i class="icon-check-stroke"></i>
                <span class="txt ml-5">Sınavı Sonlandır</span>
              </li>
            </ul>
          </div>

          <div class="right fw-bold">
            <div class="mr-10" v-show="timeVisible">
              <span class="text-gray-soft mr-3">
                Kalan Süre:
                <span class="text-navy fw-900">{{ remaining }}</span>
              </span>

              <span class="text-gray-soft d-block">
                Saat: <span class="text-navy fw-900">{{ time }}</span>
              </span>
            </div>

            <button
              class="btn-visible ml-auto"
              @click="timeVisible = !timeVisible"
            >
              <svg
                v-show="timeVisible"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.854021 0.146143C0.807533 0.0996553 0.752344 0.0627792 0.691605 0.0376201C0.630865 0.012461 0.565765 -0.000488281 0.500021 -0.000488281C0.434277 -0.000488282 0.369177 0.012461 0.308438 0.0376201C0.247698 0.0627792 0.192509 0.0996553 0.146021 0.146143C0.0995332 0.192631 0.0626571 0.24782 0.037498 0.30856C0.0123389 0.369299 -0.000610352 0.434399 -0.000610352 0.500143C-0.000610351 0.565887 0.0123389 0.630987 0.037498 0.691727C0.0626571 0.752466 0.0995332 0.807655 0.146021 0.854143L3.64602 4.35214C1.91259 5.53447 0.705829 7.34355 0.280021 9.39814C0.266626 9.46242 0.266024 9.52872 0.278249 9.59323C0.290473 9.65775 0.315285 9.71922 0.351268 9.77415C0.38725 9.82907 0.433699 9.87637 0.487962 9.91335C0.542225 9.95032 0.603239 9.97625 0.667521 9.98964C0.731803 10.003 0.798094 10.0036 0.862609 9.99142C0.927124 9.97919 0.988599 9.95438 1.04352 9.9184C1.09845 9.88241 1.14575 9.83596 1.18273 9.7817C1.2197 9.72744 1.24563 9.66643 1.25902 9.60214C1.44991 8.67863 1.82311 7.80248 2.35678 7.02498C2.89045 6.24748 3.57387 5.58426 4.36702 5.07414L5.95002 6.65614C5.53745 6.95207 5.1942 7.33422 4.94409 7.77607C4.69398 8.21793 4.543 8.70891 4.50162 9.21495C4.46025 9.72099 4.52946 10.23 4.70447 10.7066C4.87948 11.1832 5.15609 11.616 5.51511 11.9751C5.87413 12.3341 6.30696 12.6107 6.78357 12.7857C7.26019 12.9607 7.76917 13.0299 8.27522 12.9885C8.78126 12.9472 9.27224 12.7962 9.71409 12.5461C10.1559 12.296 10.5381 11.9527 10.834 11.5401L15.147 15.8541C15.2409 15.948 15.3682 16.0008 15.501 16.0008C15.6338 16.0008 15.7611 15.948 15.855 15.8541C15.9489 15.7603 16.0017 15.6329 16.0017 15.5001C16.0017 15.3674 15.9489 15.24 15.855 15.1461L0.855021 0.146143H0.854021Z"
                  fill="#717B96"
                />
                <path
                  d="M8.12402 6.00293L11.487 9.36593C11.4532 8.48483 11.088 7.64897 10.4645 7.02547C9.84098 6.40198 9.00513 6.03679 8.12402 6.00293V6.00293Z"
                  fill="#717B96"
                />
                <path
                  d="M5.53101 3.41L6.33401 4.213C6.87807 4.07168 7.43789 4.00011 8.00001 4C11.206 4 14.057 6.327 14.74 9.602C14.7671 9.73196 14.8446 9.84584 14.9556 9.91861C15.0667 9.99137 15.2021 10.0171 15.332 9.99C15.462 9.96295 15.5758 9.88538 15.6486 9.77436C15.7214 9.66334 15.7471 9.52796 15.72 9.398C14.943 5.673 11.693 3 8.00001 3C7.14501 3 6.31301 3.143 5.53101 3.41V3.41Z"
                  fill="#717B96"
                />
              </svg>

              <svg
                v-show="!timeVisible"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.72998 10.7812V10.785C3.70893 10.8644 3.67243 10.9389 3.62258 11.0041C3.57273 11.0694 3.5105 11.1242 3.43946 11.1654C3.36841 11.2067 3.28993 11.2335 3.20852 11.2443C3.1271 11.2552 3.04435 11.2499 2.96498 11.2287C2.42623 11.0862 2.52123 10.465 2.52123 10.465L2.54248 10.3875C2.54248 10.3875 2.57498 10.2825 2.60123 10.2062C2.922 9.30686 3.39423 8.46895 3.99748 7.72875C5.12123 6.36125 7.00748 5 9.99998 5C12.9937 5 14.88 6.36125 16.0012 7.72875C16.6045 8.46895 17.0767 9.30686 17.3975 10.2062C17.4244 10.2835 17.4494 10.3615 17.4725 10.44L17.4762 10.4562L17.4787 10.4613V10.4638C17.5184 10.6228 17.4939 10.7911 17.4107 10.9324C17.3274 11.0736 17.1919 11.1764 17.0336 11.2187C16.8752 11.261 16.7065 11.2394 16.5639 11.1585C16.4213 11.0776 16.3162 10.9439 16.2712 10.7862L16.27 10.7812L16.26 10.75C16.189 10.5288 16.1056 10.3117 16.01 10.1C15.7551 9.53352 15.4274 9.00277 15.035 8.52125C14.1062 7.39 12.555 6.25 9.99998 6.25C7.44498 6.25 5.89248 7.39 4.96498 8.52125C4.45562 9.14686 4.0562 9.85442 3.78373 10.6138C3.76828 10.6589 3.7537 10.7043 3.73998 10.75L3.72998 10.7812V10.7812Z"
                  fill="#717B96"
                />
                <path
                  d="M6.875 11.875C6.875 11.0462 7.20424 10.2513 7.79029 9.66529C8.37634 9.07924 9.1712 8.75 10 8.75C10.8288 8.75 11.6237 9.07924 12.2097 9.66529C12.7958 10.2513 13.125 11.0462 13.125 11.875C13.125 12.7038 12.7958 13.4987 12.2097 14.0847C11.6237 14.6708 10.8288 15 10 15C9.1712 15 8.37634 14.6708 7.79029 14.0847C7.20424 13.4987 6.875 12.7038 6.875 11.875Z"
                  fill="#717B96"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="bla-card__body">
        <div class="bla-card__top">
          <span class="q-num">{{ currentQuestion.index + 1 }}.</span>

          <div
            class="q-bookmark"
            @click="toggleBookmark(true)"
            v-show="!markedQuestions.includes(currentQuestion.id)"
          >
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8674 40.0172C10.6509 40.162 10.3991 40.2453 10.1389 40.2581C9.87875 40.271 9.61999 40.2129 9.39029 40.09C9.16059 39.9672 8.96858 39.7843 8.83477 39.5608C8.70097 39.3373 8.6304 39.0817 8.63062 38.8212V11.5346C8.63061 10.0116 9.23484 8.55077 10.3107 7.47276C11.3865 6.39476 12.8461 5.78761 14.3691 5.78457L31.6191 5.75294C32.3742 5.75143 33.1222 5.89866 33.8204 6.18623C34.5186 6.4738 35.1533 6.89607 35.6884 7.42894C36.2234 7.96181 36.6482 8.59484 36.9385 9.29189C37.2289 9.98893 37.3791 10.7363 37.3806 11.4914V38.8212C37.3808 39.0817 37.3103 39.3373 37.1765 39.5608C37.0427 39.7843 36.8506 39.9672 36.6209 40.09C36.3912 40.2129 36.1325 40.271 35.8723 40.2581C35.6122 40.2453 35.3604 40.162 35.1439 40.0172L23.0056 31.9097L10.8645 40.0172H10.8674ZM34.5027 11.5001L34.4826 11.1608C34.3995 10.4615 34.0626 9.817 33.5359 9.34959C33.0091 8.88218 32.3291 8.62437 31.6249 8.62507L14.3749 8.65382C13.6134 8.65534 12.8836 8.95891 12.3456 9.49792C11.8077 10.0369 11.5056 10.7673 11.5056 11.5288V36.1302L22.2064 28.9829C22.4426 28.8253 22.7202 28.7412 23.0042 28.7412C23.2882 28.7412 23.5658 28.8253 23.802 28.9829L34.5056 36.1302V11.5001H34.5027Z"
                fill="black"
              />
            </svg>
          </div>

          <div
            class="q-bookmark"
            @click="toggleBookmark(false)"
            v-show="markedQuestions.includes(currentQuestion.id)"
          >
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8674 40.0167C10.6509 40.1615 10.3991 40.2448 10.1389 40.2576C9.87875 40.2705 9.61999 40.2124 9.39029 40.0895C9.16059 39.9667 8.96858 39.7838 8.83477 39.5603C8.70097 39.3368 8.6304 39.0812 8.63062 38.8207V11.5341C8.63061 10.0111 9.23484 8.55028 10.3107 7.47228C11.3865 6.39427 12.8461 5.78712 14.3691 5.78408L31.6191 5.75245C32.3742 5.75094 33.1222 5.89817 33.8204 6.18574C34.5186 6.47331 35.1533 6.89558 35.6884 7.42845C36.2234 7.96132 36.6482 8.59435 36.9385 9.2914C37.2289 9.98844 37.3791 10.7359 37.3806 11.491V38.8207C37.3808 39.0812 37.3103 39.3368 37.1765 39.5603C37.0427 39.7838 36.8506 39.9667 36.6209 40.0895C36.3912 40.2124 36.1325 40.2705 35.8723 40.2576C35.6122 40.2448 35.3604 40.1615 35.1439 40.0167L23.0056 31.9092L10.8645 40.0167H10.8674Z"
                fill="#FE9A38"
              />
            </svg>
          </div>
        </div>

        <div
          class="exam-container"
          v-if="currentQuestion.data && currentQuestion.data.detail"
        >
          <!--
                    <div class="q-alert q-alert__info mb-3">7-16 sorularda, cümlede boş bırakılan yerlere uygun düşen sözcük ya da ifadeyi bulunuz.</div>
                    -->

          <div id="marker" @contextmenu.prevent="removeHighlight">
            <p
              ref="questionText"
              class="text marker_container"
              :style="{ fontSize: fontSize + 'px' }"
              v-math
              v-html="
                scaleContentFontSize(
                  getCurrentQuestionSelectedAnswerContent(getCurrentQuestion()),
                )
              "
              v-on:pointerup="highlightParagraph"
            ></p>

            <!--
                        <p class="text" :class="'questionText-' + index" :id="'questionText-' + index" v-html="actArr[index] ? actArr[index] : questions[index].text"></p>
                        -->
          </div>

          <div class="exam-options" v-if="getCurrentQuestion().detail.answers">
            <label
              @contextmenu.prevent="lineThrought(answer.id)"
              class="exam-option marker_container"
              :class="{
                selected: answer.id === currentQuestion.answer_id,
                lineThrough:
                  questionEliminatedOptions.hasOwnProperty(
                    currentQuestion.id,
                  ) &&
                  questionEliminatedOptions[currentQuestion.id] &&
                  questionEliminatedOptions[currentQuestion.id].includes(
                    answer.id,
                  ) &&
                  answer.id !== currentQuestion.answer_id,
              }"
              v-for="(answer, key) in getCurrentQuestion().detail.answers"
              :key="answer.id"
            >
              <span class="opt-key text-uppercase">{{
                  getQuestionAnswerLabel(key)
                }}</span>
              <span
                ref="optText"
                class="opt-text"
                :style="{ fontSize: fontSize + 'px' }"
                v-math
                v-html="scaleContentFontSize(answer.translate.content)"
                v-on:pointerup="highlightParagraph"
              ></span>
              <input
                type="radio"
                :id="answer.id"
                class="hidden"
                :value="answer.id"
                @change="setAnswer(answer.id)"
                v-model="currentQuestion.answer_id"
              />
            </label>
          </div>
        </div>

        <div class="q-nav-btns">
          <span
            class="q-nav-btn q-nav-btn-prev"
            @click="prevQuestion"
            v-show="currentQuestion.index !== 0"
          >
            <i class="icon-left-arrow"></i>
            <span class="text">Önceki Soru</span>
          </span>

          <span
            class="q-nav-btn q-nav-btn-next"
            @click="nextQuestion"
            v-show="currentQuestion.index + 1 !== questions.length"
          >
            <i class="icon-right-arrow"></i>
            <span class="text">Sonraki Soru</span>
          </span>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
//import date from 'date-and-time';
import moment from 'moment';
import Layout from '../components/Layout.vue';
import EventBus from '../event-bus';

export default {
  components: {Layout},
  data() {
    return {
      userSessionId: undefined,
      userSession: {},
      questions: [],
      markedQuestions: [],
      questionEliminatedOptions: {},
      currentQuestion: {
        id: undefined,
        index: 0,
        answer_id: undefined,
        data: undefined,
      },
      sessionDates: {
        starting: new Date(),
        ending: new Date(),
      },
      informationModal: undefined,
      review: {
        activeTab: 'all',
      },
      timeVisible: true,
      liveStatusIsOpen: false,
      reviewIsOpen: false,
      completeQuizIsOpen: false,
      showRightReview: false,
      time: '',
      year: '',
      timestamp: '',
      fulldatetime: '',
      examDuration: '',
      remaining: '',
      spended: '',
      initInterval: undefined,
      showRightInstance: undefined,
      actArr: [],
      fontSize: 16,
      minFontSize: 12,
      maxFontSize: 40,
      questionHighlights: {},
    };
  },
  watch: {
    // 'currentQuestion.answer_id': {
    //   handler: function() {
    //     //console.log(this.getCurrentQuestionSelectedAnswerContent());
    //   },
    //   deep: true,
    // },
    'currentQuestion.answer_id': function () {
      this.$nextTick(this.restoreHighlights);
    },
  },
  mounted() {
    //console.log(this.currentQuestion);

    const storedFontSize = parseInt(
      window.localStorage.getItem('exam_font_size'),
      10,
    );
    if (
      !isNaN(storedFontSize) &&
      storedFontSize >= this.minFontSize &&
      storedFontSize <= this.maxFontSize
    ) {
      this.fontSize = storedFontSize;
    }

    this.getUserSession();

    EventBus.$on('exam_session_checked', () => {
      this.initInterval = setInterval(() => {
        this.time = this.printTime();
        this.spended = this.spendedTime();
        this.remaining = this.remainingTime();
        this.durationTime = this.overTime();

        let isEnded =
          this.userSession &&
          this.userSession.session &&
          this.userSession.session.user_session
            ? this.userSession.session.user_session.is_ended
            : undefined;

        if (this.durationTime < 1 && typeof isEnded === 'boolean' && !isEnded) {
          if (typeof this.initInterval !== 'undefined') {
            clearInterval(this.initInterval);
          }

          this.finishExam();
        } else if (isEnded) {
          EventBus.$emit('exam_session_ended');
        }
      }, 1000);

      this.markedQuestions = this.getLocalStorage('marked_questions') || [];
      this.questionEliminatedOptions =
        this.getLocalStorage('eliminated_questions') || [];
      this.questionHighlights =
        this.getLocalStorage('question_highlights') || {};

      this.$nextTick(this.restoreHighlights);
    });

    EventBus.$on('exam_session_ended', () => {
      this.showInformationModal({
        title: 'Oturum Sonlandırıldı!',
        content:
          'Giriş yaptığınız sınav oturumu sonlandırıldı. Sınavlar sayfasına yönlendiriliyorsunuz..',
        class: 'text-danger',
      });

      setTimeout(() => {
        this.$router.push('/sinavlar');
      }, 4000);
    });

    EventBus.$on('exam_user_session_invalid', () => {
      this.showInformationModal({
        title: 'Geçersiz Sınav Oturumu!',
        content:
          'Bu sınav oturumunu bulamadık. Sınavlar sayfasına yönlendiriliyorsunuz..',
        class: 'text-danger',
      });

      setTimeout(() => {
        this.$router.push('/sinavlar');
      }, 4000);
    });

    EventBus.$on(['exam_not_active', 'invalid_exam'], () => {
      this.showInformationModal({
        title: 'Sınav Aktif Değil!',
        content:
          'Üzgünüz ancak bu sınav artık aktif değil. Sınavlar sayfasına yönlendiriliyorsunuz..',
        class: 'text-danger',
      });

      setTimeout(() => {
        this.$router.push('/sinavlar');
      }, 4000);
    });
  },
  methods: {
    changeFontSize(delta) {
      const next = this.fontSize + delta;

      if (next < this.minFontSize || next > this.maxFontSize) {
        return;
      }

      this.fontSize = next;
      window.localStorage.setItem('exam_font_size', next);
    },
    scaleContentFontSize(html) {
      if (!html) {
        return html;
      }

      return html.replace(
        /font-size\s*:\s*([\d.]+)\s*(px|pt|rem)/gi,
        (match, value, unit) => {
          const numeric = parseFloat(value);
          const lowerUnit = unit.toLowerCase();
          const px =
            lowerUnit === 'pt'
              ? numeric * (96 / 72)
              : lowerUnit === 'rem'
                ? numeric * 16
                : numeric;

          return 'font-size: ' + (px / 16).toFixed(3) + 'em';
        },
      );
    },
    getCurrentQuestionSelectedAnswerContent(currentQuestion) {
      let selectedAns;
      let answerSplit = [];
      let currentQuestionContent = currentQuestion.detail.translate.content;

      if (
        currentQuestion.answer_id != undefined &&
        currentQuestion.answer_id != null
      ) {
        selectedAns = currentQuestion.detail.answers.filter(
          (item) => currentQuestion.answer_id === item.id,
        );

        if (selectedAns.length) {
          let temp = document.createElement('p');

          temp.innerHTML = selectedAns[0].translate.content;
          answerSplit = temp.innerText.split('/');

          let blankIndex = 0;

          return currentQuestionContent.replace(/----/g, () => {
            const word = answerSplit[blankIndex];
            blankIndex++;

            return (
              '<span class="success-fill-in-the-blanks blanko">' +
              (word !== undefined ? word : '----') +
              '</span>'
            );
          });
        }
      }
      return currentQuestion.detail.translate.content;
    },
    getUserSession() {
      this.userSessionId = this.$route.params.user_session_id;

      if (!this.userSessionId) {
        this.showInformationModal({
          title: 'Oturum Bulunamadı!',
          content:
            'Girmek istediğiniz oturum bulunamadı. Lütfen sınava tekrar giriş yapmayı deneyiniz.',
          class: 'text-danger',
        });

        return;
      }

      this.axios
        .get('/module/exam/session/user-session-check/' + this.userSessionId)
        .then((response) => {
          this.userSession = response.data.data;

          this.sessionDates.starting = moment(
            this.userSession.session.full_date,
          ).toDate();
          this.sessionDates.ending = moment(
            this.userSession.without_session
              ? this.userSession.session.user_session.estimated_end_date
              : this.userSession.session.ending_date,
          ).toDate();

          this.getQuestions();

          EventBus.$emit('exam_session_checked');
        });
    },
    getQuestions() {
      this.axios
        .get('/module/exam/question?user_session_id=' + this.userSessionId)
        .then((response) => {
          this.questions = response.data.data;

          this.questions.filter((question, index) => {
            question.index = index;
          });
        })
        .then(() => {
          if (typeof this.currentQuestion.id === 'undefined') {
            this.getQuestionDetail(0);
          }

          EventBus.$emit('exam_questions_loaded');
        });
    },
    getQuestionDetail(question_id) {
      this.axios
        .get(
          '/module/exam/question/' +
          question_id +
          '?user_session_id=' +
          this.userSessionId,
        )
        .then((response) => {
          if (
            this.questions &&
            typeof response.data.data === 'boolean' &&
            !response.data.data
          ) {
            this.getQuestionDetail(this.questions[0].id);
            return;
          }

          this.currentQuestion.id = response.data.data.id;

          this.questions.forEach((question, index) => {
            if (question.id === this.currentQuestion.id) {
              this.$set(this.questions[index], 'detail', response.data.data);
            }
          });
        })
        .then(() => {
          this.getCurrentQuestion(true);
        });
    },
    getCurrentQuestion(force = false) {
      if (typeof this.currentQuestion.data !== 'undefined' && !force) {
        return this.currentQuestion.data;
      }

      let find = this.questions.filter((question, index) => {
        if (question.id === this.currentQuestion.id) {
          this.currentQuestion.index = question.index = index;

          if (question.answered) {
            this.currentQuestion.answer_id = question.answer_id;
          }

          return true;
        }
      });

      if (find.length) {
        this.currentQuestion.data = find[0];
      }

      if (force) {
        this.$nextTick(this.restoreHighlights);
      }

      return this.currentQuestion.data;
    },
    getQuestionAnswerLabel(index) {
      let characters = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'R',
        'S',
        'T',
        'U',
        'V',
        'Y',
        'Z',
      ];
      return characters[index];
    },
    setAnswer(answer_id) {
      let currentQuestion = this.getCurrentQuestion();

      if (currentQuestion.answer_id !== answer_id) {
        this.$set(this.currentQuestion.data, 'answer_id', answer_id);
        this.$set(this.currentQuestion.data, 'answered', true);

        this.sendAnswerToServer(currentQuestion.id, answer_id).then(() => {
          this.getQuestions();
        });
      }
    },
    sendAnswerToServer(question_id, answer_id) {
      return this.axios.post('/module/exam/question/answer', {
        user_session_id: this.userSessionId,
        question_id: question_id,
        answer_id: answer_id,
      });
    },
    nextQuestion() {
      let nextQuestionIndex = this.currentQuestion.index + 1;
      let nextQuestion = this.questions[nextQuestionIndex] || undefined;

      if (typeof nextQuestion !== 'undefined') {
        if (!nextQuestion.detail) {
          this.getQuestionDetail(nextQuestion.id);
        } else {
          this.currentQuestion.id = nextQuestion.id;
          this.getCurrentQuestion(true);
        }
      }
    },
    prevQuestion() {
      let previousQuestionIndex =
        this.currentQuestion.index > 0 ? this.currentQuestion.index - 1 : 0;
      let previousQuestion = this.questions[previousQuestionIndex] || undefined;

      if (typeof previousQuestion !== 'undefined') {
        if (!previousQuestion.detail) {
          this.getQuestionDetail(previousQuestion.id);
        } else {
          this.currentQuestion.id = previousQuestion.id;
          this.getCurrentQuestion(true);
        }
      }
    },
    toggleBookmark(status) {
      if (status) {
        if (!this.markedQuestions.includes(this.currentQuestion.id)) {
          this.markedQuestions.push(this.currentQuestion.id);
        }
      } else {
        if (this.markedQuestions.includes(this.currentQuestion.id)) {
          this.markedQuestions.splice(
            this.markedQuestions.indexOf(this.currentQuestion.id),
            1,
          );
        }
      }

      this.setLocalStore('marked_questions', this.markedQuestions);
    },
    lineThrought(key) {
      if (this.currentQuestion.id) {
        if (
          !Array.isArray(
            this.questionEliminatedOptions[this.currentQuestion.id],
          )
        ) {
          this.$set(
            this.questionEliminatedOptions,
            this.currentQuestion.id,
            [],
          );
        }

        if (
          this.questionEliminatedOptions[this.currentQuestion.id].includes(key)
        ) {
          this.questionEliminatedOptions[this.currentQuestion.id].splice(
            this.questionEliminatedOptions[this.currentQuestion.id].indexOf(
              key,
            ),
            1,
          );
        } else {
          this.questionEliminatedOptions[this.currentQuestion.id].push(key);
        }

        this.setLocalStore(
          'eliminated_questions',
          this.questionEliminatedOptions,
        );
      }
    },
    getStartTime() {
      return new Date(
        this.userSession.session.user_session.start_date,
      ).toLocaleTimeString();
    },
    getEndTime() {
      return new Date(this.sessionDates.ending).toLocaleTimeString();
    },
    printTime() {
      return new Date().toLocaleTimeString();
    },
    spendedTime() {
      if (
        !(
          this.userSession &&
          this.userSession.session &&
          this.userSession.session.user_session
        )
      ) {
        return;
      }

      const dateNow = new Date();

      let a = moment(dateNow);
      let b = moment(
        new Date(this.userSession.session.user_session.start_date),
      );
      let duration = moment.duration(a.diff(b));

      let hours = duration._data.hours;
      let minutes = duration._data.minutes;

      return (
        hours + ' saat ' + minutes + ' dk ' + duration._data.seconds + ' sn'
      );
    },
    remainingTime() {
      const dateNow = new Date();

      let a = moment(dateNow);
      let b = moment(new Date(this.sessionDates.ending));
      let duration = moment.duration(b.diff(a));
      let hours = duration._data.hours;
      let minutes = duration._data.minutes;

      return (
        hours + ' saat ' + minutes + ' dk ' + duration._data.seconds + ' sn'
      );
    },
    overTime() {
      let a = moment(new Date(this.sessionDates.ending));
      let b = moment(new Date());

      return a.diff(b, 'seconds');
    },
    isActiveTab(menuItem) {
      return this.review.activeTab === menuItem;
    },
    setActiveTab(menuItem) {
      this.review.activeTab = menuItem;
    },
    showRight(questionIndex) {
      let targetQuestion = this.questions[questionIndex] || undefined;

      if (typeof this.showRightInstance !== 'undefined') {
        clearTimeout(this.showRightInstance);
      }

      if (this.currentQuestion.id === targetQuestion.id) {
        return;
      }

      if (typeof targetQuestion !== 'undefined') {
        this.currentQuestion.id = targetQuestion.id;

        this.showRightInstance = setTimeout(() => {
          if (!targetQuestion.detail) {
            this.getQuestionDetail(targetQuestion.id);
          } else {
            this.currentQuestion.id = targetQuestion.id;
            this.getCurrentQuestion(true);
          }

          this.showRightInstance = undefined;
        }, 500);
      }

      this.showRightReview = true;
    },
    goQuestion() {
      this.reviewIsOpen = false;
    },
    closeLeftMenus() {
      this.liveStatusIsOpen = false;
      this.reviewIsOpen = false;
      this.completeQuizIsOpen = false;
    },
    finishExam() {
      this.closeLeftMenus();

      this.showInformationModal({
        title: 'Sınav Tamamlandı.',
        content: 'Sınavlar sayfasına yönlendiriliyorsunuz...',
        class: 'text-primary',
      });

      this.axios
        .post('/module/exam/finish', {
          user_session_id: this.userSessionId,
        })
        .then((response) => {
          setTimeout(() => {
            this.$router.push('/sinavlar');
          }, 2000);
        });

      this.forgetLocalStorage('marked_questions');
      this.forgetLocalStorage('eliminated_questions');
      this.forgetLocalStorage('question_highlights');
    },
    showInformationModal(data) {
      this.informationModal = data;

      if (data.timeout) {
        setTimeout(() => {
          this.informationModal = undefined;
        }, data.timeout);
      }
    },
    getLocalStorage(selector) {
      let stored = window.localStorage.getItem(selector) || undefined;

      if (typeof stored !== 'undefined') {
        stored = JSON.parse(stored);

        if (stored.hasOwnProperty(this.userSession.id)) {
          return stored[this.userSession.id];
        }
      }
    },
    setLocalStore(selector, data) {
      let stored = window.localStorage.getItem(selector) || undefined;

      if (typeof stored === 'undefined') {
        stored = {};
      } else {
        stored = JSON.parse(stored);
      }

      if (!stored.hasOwnProperty(this.userSession.id)) {
        stored[this.userSession.id] = [];
      }

      stored[this.userSession.id] = data;

      window.localStorage.setItem(selector, JSON.stringify(stored));
    },
    forgetLocalStorage(selector) {
      let stored = window.localStorage.getItem(selector) || undefined;

      if (typeof stored !== 'undefined') {
        stored = JSON.parse(stored);

        if (stored.hasOwnProperty(this.userSession.id)) {
          delete stored[this.userSession.id];
          window.localStorage.setItem(selector, JSON.stringify(stored));
        }
      }
    },
    resetPage() {
      this.userSessionId = undefined;
      this.userSession = {};
      this.questions = [];
      this.markedQuestions = [];
      this.questionEliminatedOptions = {};
      this.questionHighlights = {};
      this.currentQuestion = {
        id: undefined,
        index: 0,
        answer_id: undefined,
        data: undefined,
      };
      this.sessionDates = {
        starting: new Date(),
        ending: new Date(),
      };
      this.informationModal = undefined;
      this.review = {
        activeTab: 'all',
      };

      this.forgetLocalStorage('marked_questions');
      this.forgetLocalStorage('eliminated_questions');
      this.forgetLocalStorage('question_highlights');
    },

    removeHighlight() {
      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        document.selection.empty();
      }
    },
    highlightParagraph(event) {
      //if (window.getSelection().focusNode.parentElement.closest("#marker").id != "marker") return;

      event.preventDefault();

      if (window.getSelection().anchorNode === null) {
        return;
      }

      const selection = window.getSelection().getRangeAt(0);
      let selectedParent = selection.commonAncestorContainer.parentElement;

      if (
        !selectedParent.parentElement.classList.contains('marker_container')
      ) {
        selectedParent = selectedParent.closest('.marker_container');

        if (!selectedParent) {
          return;
        }
      }

      if (!selectedParent.closest('mark')) {
        const span = document.createElement('mark');
        span.className = 'highlight p-0';
        span.appendChild(selection.extractContents());

        span.querySelectorAll('mark').forEach((innerMark) => {
          while (innerMark.firstChild) {
            innerMark.parentNode.insertBefore(innerMark.firstChild, innerMark);
          }
          innerMark.remove();
        });
        span.normalize();

        span.addEventListener('contextmenu', this.unwrapConnectedHighlights);

        selection.insertNode(span);
        selectedParent.normalize();

        this.saveHighlights();
      }

      this.removeHighlight();
    },
    unwrapConnectedHighlights(event) {
      event.preventDefault();

      const clicked = event.currentTarget;

      const isMark = (node) =>
        node && node.nodeType === 1 && node.tagName === 'MARK';

      const skipBlankText = (node, dir) => {
        let sib = node[dir];

        while (sib && sib.nodeType === 3 && sib.data.trim().length === 0) {
          sib = sib[dir];
        }

        return sib;
      };

      const found = new Set();
      const stack = [clicked];

      while (stack.length) {
        const mark = stack.pop();

        if (!isMark(mark) || found.has(mark)) {
          continue;
        }

        found.add(mark);

        const prev = skipBlankText(mark, 'previousSibling');
        if (isMark(prev)) stack.push(prev);

        const next = skipBlankText(mark, 'nextSibling');
        if (isMark(next)) stack.push(next);

        if (isMark(mark.parentNode)) stack.push(mark.parentNode);

        mark.querySelectorAll('mark').forEach((inner) => stack.push(inner));
      }

      const parent = clicked.parentNode;

      found.forEach((mark) => {
        while (mark.firstChild) {
          mark.parentNode.insertBefore(mark.firstChild, mark);
        }

        mark.remove();
      });

      if (parent) {
        parent.normalize();
      }

      this.saveHighlights();
    },
    saveHighlights() {
      const id = this.currentQuestion.id;

      if (!id) {
        return;
      }

      const hasMark = (el) => !!(el && el.querySelector('mark'));

      const questionEl = this.$refs.questionText;
      const optionEls = this.normalizeRefList(this.$refs.optText);

      const record = {
        question: hasMark(questionEl) ? questionEl.innerHTML : null,
        answerId:
          this.currentQuestion.answer_id != null
            ? this.currentQuestion.answer_id
            : null,
        options: optionEls.map((el) => (hasMark(el) ? el.innerHTML : null)),
      };

      if (!record.question && !record.options.some(Boolean)) {
        this.$delete(this.questionHighlights, id);
      } else {
        this.$set(this.questionHighlights, id, record);
      }

      this.setLocalStore('question_highlights', this.questionHighlights);
    },
    restoreHighlights() {
      const id = this.currentQuestion.id;

      if (!id) {
        return;
      }

      const record = this.questionHighlights[id];

      if (!record) {
        return;
      }

      const questionEl = this.$refs.questionText;

      if (
        questionEl &&
        record.question &&
        record.answerId == this.currentQuestion.answer_id
      ) {
        questionEl.innerHTML = record.question;
        this.attachHighlightHandlers(questionEl);
      }

      const optionEls = this.normalizeRefList(this.$refs.optText);

      optionEls.forEach((el, index) => {
        if (el && record.options && record.options[index]) {
          el.innerHTML = record.options[index];
          this.attachHighlightHandlers(el);
        }
      });
    },
    attachHighlightHandlers(el) {
      el.querySelectorAll('mark').forEach((mark) => {
        mark.addEventListener('contextmenu', this.unwrapConnectedHighlights);
      });
    },
    normalizeRefList(ref) {
      if (!ref) {
        return [];
      }

      return Array.isArray(ref) ? ref : [ref];
    },
  },
  computed: {
    filteredQuestions() {
      switch (this.review.activeTab) {
        case 'answered':
          return this.questions.filter(
            (question) => question.answered && question.answer_id !== 0,
          );
        case 'empty':
          return this.questions.filter(
            (question) => question.answer_id === 0 || !question.answered,
          );
        case 'marked':
          return this.questions.filter(
            (question) =>
              this.markedQuestions &&
              this.markedQuestions.includes(question.id),
          );
        default:
          return this.questions;
      }
    },
  },
  beforeDestroy() {
    this.resetPage();

    if (typeof this.initInterval !== 'undefined') {
      clearInterval(this.initInterval);
    }
  },
};
</script>

<style>
.exam-options .opt-text,
.exam-options .opt-text * {
  font-family: inherit !important;
  font-weight: 600 !important;
}

.exam-options p,
.exam-options h1,
.exam-options h2,
.exam-options h3,
.exam-options h4,
.exam-options h5,
.exam-options h6 {
  margin: 0;
}

.bla-card__header > .first {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.font-sizer {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.12);
  border-radius: 7px;
  padding: 3px;
}

.font-sizer__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 30px;
  padding: 0 8px;
  border: none;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.9);
  color: var(--quiz-navy);
  cursor: pointer;
  line-height: 1;
  transition: 0.15s;
}

.font-sizer__btn:hover:not(:disabled) {
  background-color: #ffffff;
}

.font-sizer__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.font-sizer__a {
  font-weight: 800;
}

.font-sizer__a--sm {
  font-size: 0.8rem;
}

.font-sizer__a--lg {
  font-size: 1.1rem;
}

.font-sizer__sign {
  font-weight: 800;
  font-size: 0.9rem;
  margin-left: 1px;
}

.font-sizer__value {
  min-width: 34px;
  text-align: center;
  color: #ffffff;
  font-weight: 800;
  font-size: 1rem;
  padding: 0 8px;
}

/* Mobilde: başlık üstte, font boyutu kontrolü başlığın hemen altında. */
@media (max-width: 767.98px) {
  .bla-card__header > .first {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .font-sizer {
    align-self: flex-start;
  }
}

.success-fill-in-the-blanks {
  color: #d62d20;
}

.lineThrough {
  text-decoration: line-through;
  opacity: 0.6;
}

.highlight {
  background-color: yellow;
}

.highlight::selection {
  background-color: yellow;
}

.review-nums .review-num.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
